// this is an autogenerated file from DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskUpdate/Tags/Content/mutation-delete-tag.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_EditAutomation_EventActions_Content_EventAction_Content_Content_Content_TaskUpdate_Tags_Content($id: uuid!) {
  delete_tasks_tags_by_pk(id: $id) {
    id
  }
}

`